import { useQueryEndpoint } from "../../hooks/QueryHooks"
import { usePartnerAtom } from "../../hooks/PartnerHooks"
import { localStorageKeys, setLocalStorageValueByKey } from "../../hooks/LocalStorageHooks"
import { Autocomplete, TextField, Box } from "@mui/material"
import LoadingSpinner from "../../components/Loading/LoadingSpinner"

export const PartnerSelector = () => {
	const [partner, setPartner] = usePartnerAtom()
	const { data, error, loaded } = useQueryEndpoint("/admin/partner-code-list", false, "get")

	const updatePartner = (newValue) => {
		const selectedPartner = newValue || ""
		setPartner(selectedPartner)
		setLocalStorageValueByKey(localStorageKeys.PARTNER_CODE, selectedPartner)
	}

	// Extract partner array - handle both success and error cases
	// Ensure partnerArray is always an array
	const partnerArray = (!error && data?.data && Array.isArray(data.data)) ? data.data : []

	// Show loading spinner while fetching
	if (!loaded) {
		return (
			<Box
				sx={{
					borderRadius: 1,
					border: 1,
					borderColor: 'divider',
					p: 1,
					height: 35,
					width: 250,
					mr: '15px',
					position: 'relative',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					boxShadow: 2
				}}
			>
				<LoadingSpinner />
			</Box>
		)
	}

	return (
		<Autocomplete
			options={partnerArray}
			value={partner || null}
			onChange={(event, newValue) => updatePartner(newValue)}
			disableClearable={false}
			clearOnEscape
			size="small"
			sx={{
				width: 250,
				mr: '15px',
				'& .MuiOutlinedInput-root': {
					height: 35,
					padding: '0 9px'
				}
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder="Select partner"
					variant="outlined"
				/>
			)}
		/>
	)
}
